module.exports = "https://coursera_assets.s3.amazonaws.com/images/fe1400b5e7961760164fc58ea2737840.png";